import React from "react";
import { Link } from "react-router-dom";

export const PractitionerCell = ({ practitioner }) => {
    return (
        practitioner ?
        <div className = "d-flex flex-column-reverse">
            { practitioner.card_payment_activated ? (
                    <span className = "m-auto d-none d-md-inline">
                        <i className = "material-icons material-icons-outlined">
                            credit_card
                        </i>
                    </span>
                ):
                    <span className = "m-auto d-none d-md-inline">
                        <i className = "material-icons material-icons-outlined text-danger">
                            credit_card_off
                        </i>
                    </span>
            }
            <Link
                to = { `/praticiens/${ practitioner.id }/profil/connect` }
                style = {{ whiteSpace: 'unset' }}
                className = "table__color__links"
            >
                <span> { practitioner.last_name } </span>
                <br/>
                <span> { practitioner.first_name } </span>
            </Link>
        </div>
        :
        <span> Non définie </span>
    )
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/AppointmentsTable/Cell/PractitionerCell.js